import styled from 'styled-components/macro';
import { Controls } from 'app/components/Controls';

export const FormControls = styled(Controls)`
  margin-top: ${({ theme }) => theme.spacing.sp24};
`;
